var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"id":"comment_area","config":_vm.editorConfig,"label":_vm.label,"autofocus":_vm.focus},model:{value:(_vm.object.content),callback:function ($$v) {_vm.$set(_vm.object, "content", $$v)},expression:"object.content"}})}
var staticRenderFns = []

export { render, staticRenderFns }